import { render } from "./MoblieView.vue?vue&type=template&id=1029480e&scoped=true"
import script from "./MoblieView.vue?vue&type=script&lang=js"
export * from "./MoblieView.vue?vue&type=script&lang=js"

import "./MoblieView.vue?vue&type=style&index=0&id=1029480e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1029480e"]])

export default __exports__